export enum SortType {
	SortRecords,
	SortArray,
}
